module.exports = __webpack_public_path__ + "static/media/Projects-Inactive.67950235.svg";